import Head from "next/head";

export function MiddlewareIoHeaderContainer() {
  if (process?.env?.NODE_ENV == "development") return null;

  return (
    <Head>
      <script
        src="https://cdnjs.middleware.io/browser/libs/1.0.3-nzcm/middleware-rum.min.js"
        id="middleware-lib"
      />
      <script
        id="middleware-init"
        nonce={process.env.middlewareInitScriptNonce}
        dangerouslySetInnerHTML={{
          __html: `
            setTimeout(() => {
              if (window.Middleware) {
                window.Middleware.track({
                  serviceName:"flex2FrontendDev",
                  projectName:"flex2FrontendDev",
                  accountKey:"joucpkccnsjsbyvzukdgbupwwstkuhkadrwe",
                  target: "https://wcchz.middleware.io",
                  tracePropagationTargets: [/.*/],          
                  defaultAttributes: {"app.version": "1.0.0"},
                  recordingOptions: {
                    maskTextSelector: "*",
                    maskAllInputs: true,
                  }
                });
              }
            }, 3000);
          `,
        }}
      />
    </Head>
  );
}
